import az from './az-ui.json';
import reviewed from './az-reviewed.json';
import cabinet from './cabinetMessages';
import people from './peopleMessages';

const KEY = 'audit-pro:ui-locale';
export function getUiLocale() {
  try { return localStorage.getItem(KEY) === 'az' ? 'az' : 'ru'; } catch { return 'ru'; }
}
export function setUiLocale(locale) {
  if (!['ru', 'az'].includes(locale)) throw new Error('Unsupported interface language');
  localStorage.setItem(KEY, locale);
  // Cabinet follows the explicit global selection, not a stale previous value.
  localStorage.setItem('audit-pro:cabinet-locale', locale);
}
export function uiText(text, values = {}, locale = getUiLocale()) {
  if (typeof text !== 'string' || !text.trim()) return text;
  const raw = locale === 'az' ? (people[text.trim()] || reviewed[text.trim()] || cabinet[text]?.az || cabinet[text.trim()]?.az || az[text] || az[text.trim()] || text) : text;
  const translated = text.match(/^\s*/)[0] + raw.trim() + text.match(/\s*$/)[0];
  return translated.replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
}
